<template>
  <div>
    <div style="padding: 20px; color: #d6e6f8">
      <van-row style="padding: 13px 0px; font-size: 16px">
        <van-col :span="12">
          <van-icon name="arrow-left" size="24" @click="$router.back();" />
        </van-col>
        <van-col :span="12" class="txt-right">
          <van-popover
            v-if="actions.length > 0"
            v-model="showPopover"
            theme="dark"
            trigger="click"
            placement="bottom-end"
          >
            <ul>
              <li
                @click="changeLang(item)"
                v-for="(item, index) in actions"
                :key="index"
                class="lang-item-box"
              >
                <div style="float: left; height: 30px; line-height: 30px">
                  {{ item.language_name }}
                </div>
                <div style="float: right; height: 30px; line-height: 30px">
                  <img
                    :src="require('@/assets/lang/' + item.file_name + '.png')"
                    style="width: 17px; height: 13px"
                  />
                </div>
              </li>
            </ul>
            <template #reference>
              <li class="lang-item" v-if="langval && langval.length > 0">
                <div class="lang-item-icon">
                  <img
                    v-if="langval && langval != 'zh-CN'"
                    :src="require('@/assets/lang/' + langval + '.png')"
                    style="width: auto; height: 18px;margin-top: 4px;"
                  />
                </div>
              </li>
              <li class="lang-item" v-else>
                <div class="lang-item-icon">
                  <svg-icon icon-class="lang" style="font-size: 24px" />
                </div>
              </li>
            </template>
          </van-popover>
        </van-col>
      </van-row>
      <div class="login-title">{{ $t('register.login') }}</div>
      <van-form ref="frm" @submit="onSubmit">
        <div style="margin-bottom: 20px">
          <div>{{ $t('other.account') }}</div>
          <div>
            <van-field
              v-model="frm.username"
              style="
                border-bottom: 1px solid #6a879d !important;
                color: #fff !important;
              "
              :rules="[{ required: true }]"
              :placeholder="$t('register.accountplaceholder')"
            />
          </div>
        </div>
        <div style="margin-bottom: 20px">
          <div>{{ $t('other.pwd') }}</div>
          <div>
            <van-field
              v-model="frm.password"
              :type="isopen ? 'text' : 'password'"
              style="
                border-bottom: 1px solid #6a879d !important;
                color: #fff !important;
              "
              :placeholder="$t('register.pwdplaceholder')"
              :rules="[{ required: true }]"
            >
              <template #right-icon>
                <van-icon
                  name="eye-o"
                  v-if="isopen"
                  @click="isopen = !isopen"
                />
                <van-icon name="closed-eye" v-else @click="isopen = !isopen" />
              </template>
            </van-field>
          </div>
        </div>
        <div>
          <van-field name="checkboxGroup">
            <template #input>
              <van-checkbox-group v-model="checkboxGroup">
                <van-checkbox name="1" shape="square" icon-size="16px"
                  ><span style="color: #6a879d !important; font-size: 16px">{{
                    $t('register.remember')
                  }}</span></van-checkbox
                >
              </van-checkbox-group>
            </template>
          </van-field>
        </div>
        <div style="margin: 16px 0px">
          <van-button native-type="submit" class="web-btn">
            <van-loading v-if="posting" /><span v-else>{{
              $t('other.loginbtn')
            }}</span></van-button
          >
        </div>
      </van-form>
      <van-row style="padding: 10px 0px; font-size: 16px">
        <van-col :span="12">
          <span
            @click="jumpUrl(safeWapConfig.custom_service)"
            style="color: #6a879d !important"
            ><router-link style="    color: rgb(106, 135, 157) !important;" :to="'/findpwd'">{{ $t('register.fotget') }}</router-link></span
          >
        </van-col>
        <van-col :span="12" class="txt-right link-btn">
          <router-link
            class="link-btn"
            :to="'/register'"
            style="color: #6a879d !important"
            >{{ $t('other.toregister1') }}</router-link
          >
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import {
  setToken,
  getToken,
  setTokenbyName,
  getTokenbyName,
  TokenAccount,
  TokenLangKey
} from '@/utils/cookies'
export default {
  name: 'LoginView',
  inject: ['app'],
  computed: {
    safeWapConfig () {
      return this.app.wapConfig || {}
    }
  },
  data () {
    return {
      showPopover: false,
      actions: [],
      langval: null,
      isdefault: null,
      isopen: false,
      posting: false,
      checkboxGroup: [],
      frm: {
        username: null,
        password: null
      }
    }
  },
  mounted () {
    this.langval = getTokenbyName(TokenLangKey)
    this.getLangList()
    if (getToken()) {
      this.$router.push({ name: "home" });
    }
    const tmpfrm = getTokenbyName(TokenAccount)
    if (tmpfrm) {
      this.frm = tmpfrm
      this.checkboxGroup = ['1']
    }
  },
  methods: {
    getlangName (val) {
      let reuslt = val
      this.actions.forEach(item => {
        if (val == item.file_name) {
          reuslt = item.language_name
        }
      })
      return reuslt
    },
    async changeLang (item) {
      this.showPopover = false
      setTokenbyName(TokenLangKey, item.file_name)
      await this.$http({
        method: 'get',
        url: 'setLang',
        data: { lang: item.file_name }
      }).then(() => {})
      location.reload()
    },
    async getLangList () {
      await this.$http({
        method: 'get',
        url: 'getLangList'
      }).then(res => {
        this.actions = res.data.list
        this.langval = getTokenbyName(TokenLangKey)
        if (!(this.langval && this.langval.length > 0)) {
          this.actions.forEach(element => {
            if (element.is_default == 1) {
              this.langval = element.file_name
              setTokenbyName(TokenLangKey, this.langval)
              location.reload()
            }
          })
        }
      })
    },
    async onSubmit () {
      if (this.posting) {
        return
      }
      this.posting = true
      if (this.type == 0) this.frm.email = this.tmp
      else this.frm.phone = this.tmp
      await this.$http({
        method: 'post',
        url: 'login',
        data: this.frm
      })
        .then(res => {
          this.posting = false
          if (this.checkboxGroup && this.checkboxGroup.length > 0) {
            setTokenbyName(TokenAccount, this.frm)
          }
          setToken(res.data.userinfo.token)
          location.reload()
        })
        .catch(() => {
          this.posting = false
        })
    }
  }
}
</script>
<style scoped>
.login-title {
  color: #d6e6f8;
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 30px;
}
</style>
